/* Web Audio synth — no asset files. Tiny, cute SFX. */

let ctx = null;
let muted = false;

const getCtx = () => {
  if (!ctx) {
    try {
      const C = window.AudioContext || window.webkitAudioContext;
      ctx = new C();
    } catch { ctx = null; }
  }
  return ctx;
};

const tone = ({ freq = 440, dur = 0.12, type = "sine", gain = 0.18, slide = 0, attack = 0.005, release = 0.05 }) => {
  if (muted) return;
  const c = getCtx();
  if (!c) return;
  const t0 = c.currentTime;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, t0);
  if (slide) o.frequency.exponentialRampToValueAtTime(Math.max(40, freq + slide), t0 + dur);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(gain, t0 + attack);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  o.connect(g).connect(c.destination);
  o.start(t0);
  o.stop(t0 + dur + release);
};

export const SFX = {
  catch:    () => tone({ freq: 720, dur: 0.10, type: "sine",     gain: 0.18, slide: 220 }),
  combo:    (n=1) => tone({ freq: 600 + n * 80, dur: 0.10, type: "triangle", gain: 0.18 }),
  flower:   () => tone({ freq: 880, dur: 0.18, type: "triangle", gain: 0.20, slide: 320 }),
  photo:    () => { tone({ freq: 600, dur: 0.10, type: "square", gain: 0.12 }); setTimeout(() => tone({ freq: 900, dur: 0.14, type: "square", gain: 0.13 }), 90); },
  bomb:     () => tone({ freq: 180, dur: 0.22, type: "sawtooth", gain: 0.18, slide: -90 }),
  loseLife: () => { tone({ freq: 320, dur: 0.18, type: "sawtooth", gain: 0.20, slide: -180 }); },
  click:    () => tone({ freq: 520, dur: 0.06, type: "sine",     gain: 0.10 }),
  match:    () => { tone({ freq: 660, dur: 0.10, type: "sine",   gain: 0.16 }); setTimeout(() => tone({ freq: 880, dur: 0.14, type: "sine", gain: 0.16 }), 90); },
  win:      () => {
    [523, 659, 784, 1046].forEach((f, i) =>
      setTimeout(() => tone({ freq: f, dur: 0.18, type: "triangle", gain: 0.18 }), i * 110)
    );
  },
  lose:     () => {
    [523, 392, 311].forEach((f, i) =>
      setTimeout(() => tone({ freq: f, dur: 0.22, type: "sawtooth", gain: 0.16 }), i * 130)
    );
  },
  achievement: () => {
    [784, 988, 1175, 1568].forEach((f, i) =>
      setTimeout(() => tone({ freq: f, dur: 0.14, type: "sine", gain: 0.16 }), i * 80)
    );
  },
  flap:     () => tone({ freq: 360, dur: 0.06, type: "square", gain: 0.10, slide: 120 }),
  hit:      () => tone({ freq: 220, dur: 0.10, type: "sawtooth", gain: 0.16, slide: -90 }),
};

export const setMuted = (m) => { muted = !!m; };
export const isMuted = () => muted;
export const resumeAudio = () => { const c = getCtx(); if (c && c.state === "suspended") c.resume(); };
